export const UserRoles = {
  Admin: "Admin",
  SuperAdmin: "SuperAdmin",
  IncidentsUser: "IncidentsUser",
  InternalUser: "InternalUser",
  InspectionsUser: "InspectionsUser",
  TimeSeriesUser: "TimeSeriesUser",
  PortalUser: "PortalUser",
  PortalAdmin: "PortalAdmin",
  //Event roles
  EventsAdministrator: "EventsAdministrator",
  EventsEditor: "EventsEditor",
  EventsContributor: "EventsContributor",
  EventsViewer: "EventsViewer",
  //Monitoring roles
  MonitoringAdministrator: "MonitoringAdministrator",
  MonitoringViewer: "MonitoringViewer",
  MonitoringEditor: "MonitoringEditor",
};

export const LicenseTypes = {
  Standard: "Standard",
  Admin: "Admin",
  Field: "Field",
};

export const PortalUserStatuses = {
  PendingApproval: "Pending Approval",
  Inactive: "Inactive",
  Active: "Active",
  Rejected: "Rejected",
};

export const IncidentStatuses = {
  PendingReview: "Pending Review",
  Investigation: "Investigation",
  PendingActions: "Pending Actions",
  FinalReview: "Final Review",
  Closed: "Closed",
};

export const InspectionStatuses = {
  Overdue: "Overdue",
  Completed: "Completed",
  Draft: "Draft",
};

export const PortalUserHistoryActions = {
  PageVisit: "PageVisit",
  Logout: "Logout",
  MonitoringLocationMapClick: "MonitoringLocationMapClick",
  LineChartParameterClick: "LineChartParameterClick",
  LineChartView: "LineChartView",
};

export const RtkTagTypes = {
  GetUnitConversions: "GetUnitConversions",
  GetFolders: "GetFolders",
  GetAttachments: "GetAttachments",
  GetDocuments: "GetDocuments",
  GetEvents: "GetEvents",
  GetEvent: "GetEvent",
  GetEventsForMap: "GetEventsForMap",
  SearchEvents: "SearchEvents",
  GetAuditLogs: "GetAuditLogs",
  GetPhotoImportHistories: "GetPhotoImportHistories",
  GetPhotoImportHistory: "GetPhotoImportHistory",
  GetPhotoImportHistoryResults: "GetPhotoImportHistoryResults",
  GetWorkflowSettings: "GetWorkflowSettings",
  GetEventWorkflowSettings: "GetEventWorkflowSettings",
  GetCustomers: "GetCustomers",
  GetPermits: "GetPermits",
  GetEquipment: "GetEquipment",
  GetEquipments: "GetEquipments",
  GetParameters: "GetParameters",
  GetUnusedParameters: "GetUnusedParameters",
  GetMonitoringLocations: "GetMonitoringLocations",
  GetMonitoringLocation: "GetMonitoringLocation",
  GetMonitoringEvents: "GetMonitoringEvents",
  GetMonitoringEventCount: "GetMonitoringEventCount",
  GetMonitoringResults: "GetMonitoringResults",
  GetKpis: "GetKpis",
  GetKpi: "GetKpi",
  GetKpiHistory: "GetKpiHistory",
  GetKpiDashboard: "GetKpiDashboard",
  GetInspections: "GetInspections",
  GetInspection: "GetInspection",
  GetInspectionCount: "GetInspectionCount",
  GetInspectionForms: "GetInspectionForms",
  GetInspectionForm: "GetInspectionForm",
  GetLibraryInspectionForms: "GetLibraryInspectionForms",
  GetCustomer: "GetCustomer",
  GetCorrespondenceLogs: "GetCorrespondenceLogs",
  GetUsersForCustomer: "GetUsersForCustomer",
  GetOrganizations: "GetOrganizations",
  GetContacts: "GetContacts",
  GetUsers: "GetUsers",
  GetUser: "GetUser",
  GetContactGroups: "GetContactGroups",
  GetMonitoringVarianceLimits: "GetMonitoringVarianceLimits",
  GetMonitoringLimits: "GetMonitoringLimits",
  GetImportHistory: "GetImportHistory",
  GetPortalSubmissions: "GetPortalSubmissions",
  GetPortalUsers: "GetPortalUsers",
  GetPortalUserHistory: "GetPortalUserHistory",
  GetImportSpecifications: "GetImportSpecifications",
  GetUserDashboardWidget: "GetUserDashboardWidget",
  GetOrgComplianceAndRegulations: "GetOrgComplianceAndRegulations",
  GetActions: "GetActions",
  GetAction: "GetAction",
  GetIncidents: "GetIncidents",
  GetIncident: "GetIncident",
  GetIncidentParticipants: "GetIncidentParticipants",
  GetLookups: "GetLookups",
  GetLookup: "GetLookup",
  GetParameterGroup: "GetParameterGroup",
  GetParameterGroups: "GetParameterGroups",
  GetIncidentLookups: "GetIncidentLookups",
  GetAssetSubLocations: "GetAssetSubLocations",
  GetMonitoringLocationGroup: "GetMonitoringLocationGroup",
  GetMonitoringLocationGroups: "GetMonitoringLocationGroups",
  GetEventCgms: "GetEventCgms",
  GetEventCgm: "GetEventCgm",
  GetTopics: "GetTopics",
  GetEventTopics: "GetEventTopics",
  GetTrainingCourses: "GetTrainingCourses",
  GetTrainingCourse: "GetTrainingCourse",
  GetTrainingAssignments: "GetTrainingAssignments",
  GetTrainingAssignment: "GetTrainingAssignment",
  GetEntityReviews: "GetEntityReviews",
  GetCustomFields: "GetCustomFields",
  GetStagedCommitments: "GetStagedCommitments",
};
export const EventStatuses = {
  PendingEmailReview: "Pending Email Review",
  Complete: "Complete",
  Incomplete: "Incomplete",
  PendingReview: "Pending Review",
  PendingActions: "Pending Actions",
  IncompleteOverdue: "Incomplete (Overdue)",
  Draft: "Draft",
};

export const IncidentNotificationStages = {
  IncidentInitialReportSubmitted: "IncidentInitialReportSubmitted",
  IncidentInitialReviewSubmitted: "IncidentInitialReviewSubmitted",
  IncidentInvestigationSubmitted: "IncidentInvestigationSubmitted",
  IncidentFinalReviewSubmitted: "IncidentFinalReviewSubmitted",
  IncidentActionCreated: "IncidentActionCreated",
  IncidentActionApproved: "IncidentActionApproved",
  IncidentActionCompleted: "IncidentActionCompleted",
  IncidentActionVerified: "IncidentActionVerified",
  IncidentActionDue: "IncidentActionDue",
  IncidentActionOverdue: "IncidentActionOverdue",
  IncidentPendingInitialReview: "IncidentPendingInitialReview",
  IncidentActionPendingApproval: "IncidentActionPendingApproval",
  IncidentActionPendingVerification: "IncidentActionPendingVerification",
};
export const IncidentAssignmentStages = {
  IncidentInvestigationAssigned: "IncidentInvestigationAssigned",
  IncidentInitialReviewAssigned: "IncidentInitialReviewAssigned",
  IncidentFinalReviewAssigned: "IncidentFinalReviewAssigned",
  IncidentActionApprovalAssigned: "IncidentActionApprovalAssigned",
  IncidentActionVerificationAssigned: "IncidentActionVerificationAssigned",
  IncidentActionAssigned: "IncidentActionAssigned",
};
export const EventNotificationStages = {
  EventActionCreated: "EventActionCreated",
  EventActionApproved: "EventActionApproved",
  EventActionCompleted: "EventActionCompleted",
  EventActionVerified: "EventActionVerified",
  EventActionDue: "EventActionDue",
  EventActionOverdue: "EventActionOverdue",
  EventActionPendingApproval: "EventActionPendingApproval",
  EventActionPendingVerification: "EventActionPendingVerification",
};

export const TrainingAssignmentNotificationStages = {
  TrainingAssignmentDue: "TrainingAssignmentDue",
  TrainingAssignmentOverdue: "TrainingAssignmentOverdue",
  TrainingAssignmentCompleted: "TrainingAssignmentCompleted",
  TrainingAssignmentAssigned: "TrainingAssignmentAssigned",
};

export const InspectionNotificationStages = {
  InspectionActionCreated: "InspectionActionCreated",
  InspectionActionApproved: "InspectionActionApproved",
  InspectionActionCompleted: "InspectionActionCompleted",
  InspectionActionVerified: "InspectionActionVerified",
  InspectionActionDue: "InspectionActionDue",
  InspectionActionOverdue: "InspectionActionOverdue",
  InspectionActionPendingApproval: "InspectionActionPendingApproval",
  InspectionActionPendingVerification: "InspectionActionPendingVerification",
  InspectionDue: "InspectionDue",
  InspectionOverdue: "InspectionOverdue",
  InspectionCompleted: "InspectionCompleted",
};
export const EventAssignmentStages = {
  EventActionApprovalAssigned: "EventActionApprovalAssigned",
  EventActionVerificationAssigned: "EventActionVerificationAssigned",
};

export const InspectionAssignmentStages = {
  InspectionActionApprovalAssigned: "InspectionActionAssigned",
  InspectionActionVerificationAssigned: "InspectionActionVerificationAssigned",
};
export const IncidentUserTypes = {
  InvestigationTeamMember: "InvestigationTeamMember",
  InitialReviewer: "InitialReviewer",
  FinalReviewer: "FinalReviewer",
};
export const ActionUserTypes = {
  Approver: "Approver",
  Verifier: "Verifier",
};
export const MapLayerNames = {
  MonitoringEvents: "Monitoring Events",
  MonitoringLocations: "Monitoring Locations",
  Assets: "Assets",
  Events: "Events",
};

export const MapLayerKeys = {
  MonitoringEvents: "internalMonitoring",
  Assets: "internalAssets",
  Events: "internalEvents",
  MonitoringLocations: "internalMonitoringLocations",
};

export const EntityTypes = {
  Event: "Event",
  Customer: "Customer",
  Incident: "Incident",
  IncidentInvestigation: "IncidentInvestigation",
  MonitoringEvent: "MonitoringEvent",
  MonitoringResult: "MonitoringResult",
  Action: "Action",
  MonitoringVarianceLimit: "MonitoringVarianceLimit",
  MonitoringLocation: "MonitoringLocation",
  InspectionEvent: "InspectionEvent",
  Organization: "Organization",
  Equipment: "Equipment",
  Permit: "Permit",
  TimeSeries: "TimeSeries",
  CustomerPortalUserHistory: "CustomerPortalUserHistory",
  Document: "Document",
  CorrespondenceLog: "CorrespondenceLog",
  Contact: "Contact",
  ContactGroup: "ContactGroup",
  TrainingCourse: "TrainingCourse",
  TrainingAssignment: "TrainingAssignment",
  EmailLog: "EmailLog",
  Commitment: "Commitment",
  CommitmentDeliverable: "CommitmentDeliverable",
};

export const TourTypes = {
  Initial: "Initial",
  EventsGrid: "EventsGrid",
  MonitoringGrid: "MonitoringGrid",
  IncidentsGrid: "IncidentsGrid",
};

export const MapSourceTypes = {
  Mapbox: "Mapbox",
  ArcGis: "ArcGis",
};

export const LookupTypes = {
  AssetType: "AssetType",
  EventSubCategory: "EventSubCategory",
  EventCategory: "EventCategory",
  EventLocationType: "EventLocationType",
  ContactGroupType: "ContactGroupType",
  TagGroup: "TagGroup",
  Tag: "Tag",
  TagCategory: "TagCategory",
  Unit: "Unit",
  MonitoringEventType: "MonitoringEventType",
  ActionCategory: "ActionCategory",
  ActionEvidenceRequired: "ActionEvidenceRequired",
  IncidentParticipantType: "IncidentParticipantType",
  IncidentSeverity: "IncidentSeverity",
  IncidentType: "IncidentType",
  IncidentSubType: "IncidentSubType",
  MonitoringResultType: "MonitoringResultType",
  MonitoringLimitType: "MonitoringLimitType",
  MonitoringLocationType: "MonitoringLocationType",
  //non standard
  Users: "Users",
  Assets: "Assets",
  MonitoringLocations: "MonitoringLocations",
  ImportSpecifications: "ImportSpecifications",
  PermitType: "PermitType",
  CorrespondenceLogType: "CorrespondenceLogType",
  //Topics
  PrimaryTopics: "PrimaryTopics",
  SecondaryTopics: "SecondaryTopics",
  ActionPriority: "ActionPriority",
  CommitmentCategory: "CommitmentCategory",
  CommitmentSubCategory: "CommitmentSubCategory",
  CommitmentType: "CommitmentType",
  ContactLevelOfInterest: "ContactLevelOfInterest",
  ContactLevelOfInfluence: "ContactLevelOfInfluence",
  ContactLevelOfEngagement: "ContactLevelOfEngagement",
  ContactType: "ContactType",
};

export const VarianceStatuses = {
  Exceedance: "Exceedance",
  NonExceedance: "Non-Exceedance",
};

export const CustomFieldTypes = {
  Dropdown: "Dropdown",
  Text: "Text",
  TextArea: "TextArea",
  Number: "Number",
  Date: "Date",
  DateTime: "DateTime",
  Checkbox: "Checkbox",
  MultiSelect: "MultiSelect",
  Paragraph: "Paragraph",
  Divider: "Divider",
  Signature: "Signature",
};
export const EventContactTypes = {
  Contact: "Contact",
  ContactGroup: "ContactGroup",
  User: "User",
  Event: "Event",
};

export const InspectionFormTypes = {
  IncidentInvestigation: "IncidentInvestigation",
  IncidentParticipant: "IncidentParticipant",
  Inspection: "Inspection",
};
export const LocalStorageKeys = {
  DashboardMapViewport: "dashboard-map-viewport",
  DashboardMapEnabledLayers: "layerLibraryDashboard",
  OfflineTimeout: "offlineTimeout",
  WidgetFilters: "widgetFilters",
  DisableOfflineMode: "disableOfflineMode",
  MapFilterSelectedAssets: "mapFilterSelectedAssets",
  MapFilterSelectedMonitoringLocationTypes:
    "mapFilterSelectedMonitoringLocationTypes",
  AccessToken: "access_token",
  Ip: "ip",
  OrganizationUserId: "organization_user_id",
  NameId: "name_id",
  UserRoles: "user_roles",
  EventChatId: "event_chat_id",
  MonitoringChatId: "monitoring_chat_id",
  IncidentChatId: "incident_chat_id",
  DocumentChatId: "document_chat_id",
  EventGridChatId: "event_grid_chat_id",
};
export const ActionStatuses = {
  Closed: "Closed",
  PendingApproval: "Pending Approval",
  Approved: "Approved",
  Overdue: "Overdue",
  PendingVerification: "Pending Verification",
};
export const BulkUpdateActions = {
  Update: "Update",
  UpdateIfEmpty: "UpdateIfEmpty",
  Clear: "Clear",
  Append: "Append",
  Prepend: "Prepend",
};
export const Statuses = {
  Complete: "Complete",
  Incomplete: "Incomplete",
  PendingReview: "Pending Review",
};

export const MonitoringMenuKeys = {
  Events: "Events",
  Locations: "Locations",
  Results: "Results",
  ResultsWide: "Wideresults",
  Timeseries: "Timeseries",
};

export const PhotoImportHistoryStatuses = {
  UploadingPhotos: "UploadingPhotos",
  Staged: "Staged",
  StartingModel: "StartingModel",
  AnalyzingPhotos: "AnalyzingPhotos",
  AwaitingReview: "AwaitingReview",
  Complete: "Complete",
  AwaitingModelTraining: "AwaitingModelTraining",
};

export const MonitoringLocationPortalTypes = {
  SurfaceWater: "SurfaceWater",
  GroundWater: "GroundWater",
  Wildlife: "Wildlife",
  Air: "Air",
  Vegetation: "Vegetation",
};
export const IncidentReportTypes = {
  InitialIncidentReport: "InitialIncidentReport",
  IncidentInvestigationReport: "IncidentInvestigationReport",
  FullIncidentReport: "FullIncidentReport",
};

export const IncidentStatus = {
  PendingReview: "pending review",
  Investigation: "investigation",
  PendingActions: "pending actions",
  FinalReview: "final review",
  Closed: "closed",
};

export const ComplianceApplicability = {
  NotApplicable: { id: 1, name: "Not Applicable" },
  SlightlyApplicable: { id: 2, name: "Slightly Applicable " },
  SomewhatApplicable: { id: 3, name: "Somewhat Applicable" },
  MostlyApplicable: { id: 4, name: "Mostly Applicable" },
  FullyApplicable: { id: 5, name: "Fully Applicable" },
};
